// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__3yWL6","isButton":"style_isButton__3P6rk","isActive":"style_isActive__2GKvO","titleText":"style_titleText__2LmHQ"};